import React from 'react';
import Icon from '../../../components/AppIcon';

const RequirementsSection = () => {
  const requirements = [
    {
      category: 'Qualifikation',
      icon: 'GraduationCap',
      color: 'bg-primary',
      items: [
        'Abgeschlossenes Jurastudium (1. und 2. Staatsexamen)',
        'Zulassung als Rechtsanwalt in Deutschland',
        'Auch Berufsanfänger sind herzlich willkommen',
        'Spezialisierung in einem oder mehreren Rechtsgebieten'
      ]
    },
    {
      category: 'Fähigkeiten',
      icon: 'Brain',
      color: 'bg-accent',
      items: [
        'Exzellente Kommunikationsfähigkeiten',
        'Schnelle Auffassungsgabe und Problemlösungskompetenz',
        'Empathie im Umgang mit Mandanten',
        'Strukturierte und präzise Arbeitsweise'
      ]
    },
    {
      category: 'Technische Voraussetzungen',
      icon: 'Monitor',
      color: 'bg-trust-builder',
      items: [
        'Stabile Internetverbindung (min. 50 Mbit/s)',
        'Ruhiger Arbeitsplatz für Telefonate',
        'Moderne Computer-/Laptop-Ausstattung',
        'Grundkenntnisse in digitalen Tools'
      ]
    },
    {
      category: 'Persönlichkeit',
      icon: 'Heart',
      color: 'bg-conversion-accent',
      items: [
        'Kundenorientierte Denkweise',
        'Flexibilität und Anpassungsfähigkeit',
        'Zuverlässigkeit und Pünktlichkeit',
        'Teamgeist und Kooperationsbereitschaft'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Das bringen Sie mit
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Wir suchen qualifizierte Rechtsanwälte, die Lust auf innovative Beratungsformen haben und unsere hohen Qualitätsstandards teilen
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {requirements?.map((requirement, index) => (
            <div
              key={index}
              className="bg-surface rounded-2xl p-8 hover:shadow-elevated transition-all duration-300 card-hover"
            >
              <div className="flex items-center space-x-4 mb-6">
                <div className={`w-14 h-14 ${requirement?.color} rounded-xl flex items-center justify-center`}>
                  <Icon name={requirement?.icon} size={28} color="white" />
                </div>
                <h3 className="text-2xl font-bold text-text-primary">
                  {requirement?.category}
                </h3>
              </div>

              <ul className="space-y-4">
                {requirement?.items?.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                      <Icon name="Check" size={14} color="var(--color-primary)" />
                    </div>
                    <span className="text-text-secondary leading-relaxed">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-primary to-accent rounded-2xl p-8 lg:p-12 text-white text-center">
          <div className="max-w-3xl mx-auto">
            <Icon name="Lightbulb" size={48} color="white" className="mx-auto mb-6" />
            <h3 className="text-2xl lg:text-3xl font-bold mb-4">
              Noch nicht alle Voraussetzungen erfüllt?
            </h3>
            <p className="text-lg text-white/90 mb-6">
              Kein Problem! Wir unterstützen Sie gerne bei der Weiterbildung und helfen Ihnen dabei, die erforderlichen Qualifikationen zu erlangen.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2">
                <Icon name="BookOpen" size={20} />
                <span>Kostenlose Fortbildungen</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2">
                <Icon name="Users" size={20} />
                <span>Mentoring-Programme</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2">
                <Icon name="Award" size={20} />
                <span>Zertifizierungsunterstützung</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequirementsSection;